exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style_menuIcon__rA8-Q{font-size:1.375rem;height:2.25rem!important;padding:0!important;display:flex;align-items:center;text-decoration:none;color:#333}.style_menuIcon__rA8-Q:visited{color:#333}.style_menuIcon__rA8-Q:hover{opacity:.5}.style_disabledItem__1s4p7{cursor:not-allowed;color:#9e9e9e}", ""]);

// exports
exports.locals = {
	"menuIcon": "style_menuIcon__rA8-Q",
	"disabledItem": "style_disabledItem__1s4p7"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/Menu/style.less
// module id = 1624
// module chunks = 8